<template>
    <v-row no-gutters align="center" class="w-100 bg-black">
        <v-col 
        v-for="(content,i) in contents"
        :key="i+'content-'+content.type"
        :id="(content.id) ? content.id :'content-'+content.type+'-'+i"
        :cols="(content.cols.mobile) ? content.cols.mobile : 12"
        :md="(content.cols.tablet) ? content.cols.tablet  : 12"
        :lg="(content.cols.desktop) ? content.cols.desktop  : 12"
        :class="content.class + ' ' + ((content.has_background) ? 'bg-image' : '') "
        :style="addBackgroundImage(content)"
        >
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-if="content.type == 'html'">
                <html-component :data="content.content"></html-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'search-engine'">
                <search-engine-component :data="content.content"></search-engine-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'title'">
                <title-component :data="content.content"></title-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'text'">
                <text-component :data="content.content"></text-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'image'">
                <image-component :data="content.content"></image-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'hero-header'">
                <hero-header-component :data="content.content"></hero-header-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'view-brand-type'">
                <view-brand-type-component :data="content.content"></view-brand-type-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'button'">
                <button-component :data="content.content"></button-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'simple-slider'">
                <simple-slider-component :data="content.content"></simple-slider-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'car-details'">
                <car-details-component :data="content.content"></car-details-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'hero-detail'">
                <hero-detail-component :data="content.content"></hero-detail-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'primerent-fleet-car'">
                <primerent-fleet-car-component :data="content.content"></primerent-fleet-car-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'category-slider'">
                <category-slider-component :data="content.content"></category-slider-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'category-list'">
                <category-list-component :data="content.content"></category-list-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'full-archive'">
                <full-archive-component :data="content.content"></full-archive-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'comparison'">
                <comparison-component :data="content.content"></comparison-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'title-image-text-link'">
                <title-image-text-link-component :data="content.content"></title-image-text-link-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'image-title-button'">
                <image-title-button-component :data="content.content"></image-title-button-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'image-title-list'">
                <image-title-list-component :data="content.content"></image-title-list-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'expansion-list'">
                <expansion-list-component :data="content.content"></expansion-list-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'cards-link'">
                <cards-link-component :data="content.content"></cards-link-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'maps-preview'">
                <map-preview-component :data="content.content"></map-preview-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'seo-list-pages'">
                <seo-list-pages-component :data="content.content"></seo-list-pages-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'spacer'">
                <spacer-component :data="content.content"></spacer-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'numeric-list'">
                <numeric-list-component :data="content.content"></numeric-list-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'contact-form'">
                <contact-form-component :data="content.content"></contact-form-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'children-list'">
                <children-list-pages-component :data="content.content"></children-list-pages-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'people-list'">
                <people-list-component :data="content.content"></people-list-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'modal-availability'">
                <!-- <modal-availability-component :data="content.content"></modal-availability-component> -->
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'modal-consulting'">
                <modal-consulting-component :data="content.content"></modal-consulting-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'cars-listing'">
                <cars-listing-component :data="content.content"></cars-listing-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'quotation-request'">
                <request-quote-component :data="content.content"></request-quote-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'stepper-booking'">
                <steppers-booking-component :data="content.content"></steppers-booking-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'iubenda'">
                <iubenda-component :data="content.content"></iubenda-component>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else-if="content.type == 'row-of-contents'">
                <row-of-contents :data="content.content"></row-of-contents>
            </section>
            <section class="data-content" :class="'data-content-'+content.type+' '+content.sectionclass" v-else>
                ERR no content type found {{ content.type }}
                <pre>{{ content }}</pre>
            </section>
        </v-col>
    </v-row>
</template>

<script setup>
    import RowOfContents from './partials/RowOfContents.vue'
    import SearchEngineComponent from './partials/SearchEngineComponent.vue'
    import TitleComponent from './partials/TitleComponent.vue'
    import TextComponent from './partials/TextComponent.vue'
    import HtmlComponent from './partials/HtmlComponent.vue'
    import ImageComponent from './partials/ImageComponent.vue'
    import HeroHeaderComponent from './partials/HeroHeaderComponent.vue'
    import ViewBrandTypeComponent from './partials/ViewBrandTypeComponent.vue'
    import ButtonComponent from './partials/ButtonComponent.vue'
    import SimpleSliderComponent from './partials/SimpleSliderComponent.vue'
    import CarDetailsComponent from './partials/CarDetailsComponent.vue'
    import HeroDetailComponent from './partials/HeroDetailComponent.vue'
    import PrimerentFleetCarComponent from './partials/PrimerentFleetCarComponent.vue'
    import CategorySliderComponent from './partials/CategorySliderComponent.vue'
    import CategoryListComponent from './partials/CategoryListComponent.vue'
    import FullArchiveComponent from './partials/FullArchiveComponent.vue'
    import ComparisonComponent from './partials/ComparisonComponent.vue'
    import TitleImageTextLinkComponent from './partials/TitleImageTextLinkComponent.vue'
    import ImageTitleButtonComponent from './partials/ImageTitleButtonComponent.vue'
    import ImageTitleListComponent from './partials/ImageTitleListComponent.vue'
    import ExpansionListComponent from './partials/ExpansionListComponent.vue'
    import CardsLinkComponent from './partials/CardsLinkComponent.vue'
    import MapPreviewComponent from './partials/MapPreviewComponent.vue'
    import SeoListPagesComponent from './partials/SeoListPagesComponent.vue'
    import SpacerComponent from './partials/SpacerComponent.vue'
    import NumericListComponent from './partials/NumericListComponent.vue'
    import ContactFormComponent from './partials/ContactFormComponent.vue'
    import ChildrenListPagesComponent from './partials/ChildrenListPagesComponent.vue'
    import PeopleListComponent from './partials/PeopleListComponent.vue'
    import ModalAvailabilityComponent from './partials/ModalAvailabilityComponent.vue'
    import ModalConsultingComponent from './partials/ModalConsultingComponent.vue'
    import CarsListingComponent from './partials/CarsListingComponent.vue'
    import RequestQuoteComponent from './partials/RequestQuoteComponent.vue'
    import SteppersBookingComponent from './partials/SteppersBookingComponent.vue'
    import IubendaComponent from './partials/IubendaComponent.vue'
</script>

<script>
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

export default {
    name: "ContentsComponents",
    props:{
        contents:{
            required: true,
            type: Object,
        }
    },
    mounted(){
        AOS.init({
            startEvent: 'DOMContentLoaded',
            offset: 100,
            delay: 100,
            duration: 400,
            useClassNames: true, // if true, will add content of `data-aos` as classes on scroll
            throttleDelay: 0, // the delay on throttle used while scrolling the page (advanced)
            once: false, // whether animation should happen only once - while scrolling down
            easing: 'ease',
            anchorPlacement: 'bottom-bottom', // defines which position of the element regarding to window should trigger the animation
        });
    },
    methods:{
        addBackgroundImage(content){
            if(!content.has_background){
                return '';
            }
            if(!content.background){
                return '';
            }

            if(content.background.id){
                return "background-image: url('"+content.background.url+"')";
            }
        }
    }
}



</script>